/* Season product strips now use smooth, always-running CSS ticker; no timed step scrolling. */
/* Dynamic category related-product slider controls */
document.addEventListener('click',function(event){
 const button=event.target.closest('[data-lj-related-dir]');
 if(!button)return;
 const track=button.closest('[data-lj-related-products]')?.querySelector('[data-lj-related-scroll]');
 if(!track)return;
 const card=track.querySelector('.lj-related-products__item');
 const gap=parseFloat(window.getComputedStyle(track).columnGap)||15;
 const step=(card?.getBoundingClientRect().width||220)+gap;
 const direction=Number(button.dataset.ljRelatedDir)||1;
 track.scrollBy({left:direction*step,behavior:'smooth'});
});

/* One-outfit-at-a-time gallery with swipe, thumbnail navigation and photo zoom */
function initLJSwipeGallery(){
 document.querySelectorAll('[data-lj-gallery]').forEach(gallery=>{
  const track=gallery.querySelector('[data-lj-gallery-track]');
  const slides=Array.from(gallery.querySelectorAll('[data-lj-gallery-slide]'));
  const thumbs=Array.from(gallery.querySelectorAll('[data-lj-gallery-thumb]'));
  const counter=gallery.querySelector('[data-lj-gallery-count]');
  if(!track||!slides.length)return;
  let active=0,frame=null;
  const sync=(i)=>{
   active=Math.max(0,Math.min(slides.length-1,i));
   slides.forEach((el,j)=>el.classList.toggle('is-active',j===active));
   thumbs.forEach((el,j)=>{el.classList.toggle('is-active',j===active);el.setAttribute('aria-pressed',j===active?'true':'false')});
   if(counter)counter.textContent=(active+1)+' / '+slides.length;
  };
  const go=(i)=>{
   const next=(i+slides.length)%slides.length;
   sync(next);
   track.scrollTo({left:next*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   thumbs[next]?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
  };
  gallery.querySelector('[data-lj-gallery-prev]')?.addEventListener('click',()=>go(active-1));
  gallery.querySelector('[data-lj-gallery-next]')?.addEventListener('click',()=>go(active+1));
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>go(i)));
  track.addEventListener('scroll',()=>{if(frame)cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const width=track.clientWidth||1;sync(Math.round(track.scrollLeft/width))})},{passive:true});
  track.addEventListener('keydown',e=>{
    if(e.target!==track)return;
    if(e.key==='ArrowRight'){e.preventDefault();go(active+1)}
    if(e.key==='ArrowLeft'){e.preventDefault();go(active-1)}
  });
  sync(0);
 });
}
document.addEventListener('DOMContentLoaded',initLJSwipeGallery);
